import { AspectRatio, Box, Text } from "@chakra-ui/react";
import { FormattedMessage, useIntl } from "react-intl";

import { RanaAlert, RanaHeading } from "@nens/ranalib";

const YOUTUBE_SCHEMATISATIONS_CONVERT_EMBED_URL =
  "https://www.youtube-nocookie.com/embed/IdSZFBpWII8?rel=0";

export const TenantSchematisationHelpBanner = () => {
  const intl = useIntl();
  return (
    <RanaAlert
      alignItems="center"
      justifyContent="center"
      minW={0}
      flex={1}
      flexWrap="wrap"
      status="info"
    >
      <Box mr="auto" textAlign="start" maxW="prose" minW={0} flex="1 1 22rem">
        <RanaHeading type="h5" color="brand.clear_creek">
          <FormattedMessage
            id="text.no_model_schematisations_tenant"
            defaultMessage="There are no model schematisations for this tenant yet."
          />
        </RanaHeading>
        <Text fontWeight="light" mt={1}>
          <FormattedMessage
            id="text.no_model_schematisations_tenant_help"
            defaultMessage="If you already have a model schematisation in your project, this is the place to publish it for your colleagues. The video on the right shows how to do that."
          />
        </Text>
      </Box>

      <Box flex="0 1 22rem" maxW="full" minW={0} w="full">
        <AspectRatio ratio={16 / 9}>
          <Box
            as="iframe"
            src={YOUTUBE_SCHEMATISATIONS_CONVERT_EMBED_URL}
            title={intl.formatMessage({
              id: "text.no_model_schematisations_tenant_help_video",
              defaultMessage: "How to convert a model schematisation to a Rana model",
            })}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            borderRadius="base"
            borderWidth="base"
            borderColor="brand.sky"
            boxShadow="sm"
          />
        </AspectRatio>
      </Box>
    </RanaAlert>
  );
};
